(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["title-and-text"] && !Shopify.designMode) return;
  try {
    
    jQuery(() => {
        if($('.scroll-to').length) {
            $('.scroll-to').on('click', function(event) {
                event.preventDefault();
                const target = $(this).attr('href');
                if (target.startsWith('#')) {
                    $('html, body').animate({
                        scrollTop: $(target).offset().top - 200
                    }, 500);
                } else {
                    window.location.href = target;
                }
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
